<template>
  <v-app>
    <v-main>
      <SheetsStatus/>
    </v-main>
  </v-app>
</template>

<script>
import SheetsStatus from './components/SheetsStatus';

export default {
  name: 'App',

  components: {
    SheetsStatus,
  },

  data: () => ({
    //
  }),
};
</script>
